import { MerchantListResponse } from 'lib/generated/api'
import { NetworkList } from 'types/entities'

export type NetworkListMapper = (data: MerchantListResponse) => NetworkList

export const mapToNetworkList: NetworkListMapper = data => {
  const {
    merchants: merchantsData,
    displayHint,
    nearbyMerchantRadius,
    ...rest
  } = data.results[0]
  const merchants = !merchantsData
    ? []
    : merchantsData.map(merchant => ({
        id: merchant.merchantId,
        name: merchant.name || '',
        address: merchant.address?.addressLine1 || '',
        dateAdded: merchant.createdAt,
      }))

  return {
    merchants,
    ...rest,
  }
}
